import { Options, SDK as RAW } from '../index';
import { InMemoryCache } from '@apollo/client';
import { LocalStorageWrapper, persistCache } from 'apollo3-cache-persist';

export type LuuvioSDK = RAW;

const init = (x: LuuvioSDK): LuuvioSDK => {
    return x;
};

export class SDK extends RAW {
    static async Init(
        options: Options,
        errorCallback: (message: unknown) => unknown,
    ): Promise<SDK> {
        const cache = new InMemoryCache();
        await persistCache({
            cache,
            storage: new LocalStorageWrapper(window.localStorage),
        });
        return new SDK(options, cache, errorCallback);
    }
    constructor(
        options: Options,
        cache: InMemoryCache,
        errorCallback: (message: unknown) => unknown,
    ) {
        super(options, cache, errorCallback);
        return init(this);
    }
}
